import { EDITING_ENTITY_TYPES } from '../../utils/editCommon';

export const GET_STAFF = 'app/EditStaff/GET_STAFF';
export const UPDATE_STAFF_ACTION = 'app/EditStaff/UPDATE_STAFF_ACTION';
export const GET_STAFF_SUGGESTIONS_ACTION = 'app/EditStaff/GET_STAFF_SUGGESTIONS_ACTION';
export const ADD_STAFF_ACTION = 'app/EditStaff/ADD_STAFF_ACTION';
export const DELETE_STAFF_ACTION = 'app/EditStaff/DELETE_STAFF_ACTION';

export const entityFields = {
  [EDITING_ENTITY_TYPES.COMPANY]: {
    name: 'profile',
    employeeProfession: 'companyEmployeeProfession',
    email: 'work_email',
    phones: 'work_phones',
    entity: 'company',
  },
  [EDITING_ENTITY_TYPES.FESTIVAL]: {
    name: 'profile',
    employeeProfession: 'festivalEmployeeProfession',
    email: 'work_email',
    phones: 'phones',
    entity: 'festival',
  },
};
